export default {"src":"/_next/static/media/JP.e3e9ddce.svg","height":32,"width":48,"blurWidth":0,"blurHeight":0};